/**
 * Hero Section Component
 * Main landing section with name, title, and CTA
 */
import { Container, Row, Col, Button } from 'react-bootstrap';
import { motion } from 'framer-motion';
import { Box, Typography } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

const Hero = () => {
  // Scroll to contact section
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  // Scroll to projects section
  const scrollToProjects = () => {
    const element = document.getElementById('projects');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  // Animation variants
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.2 }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6 } }
  };

  return (
    <section id="home" className="hero-section">
      <Container>
        <Row className="align-items-center min-vh-100">
          <Col lg={8} className="hero-content">
            <motion.div
              variants={containerVariants}
              initial="hidden"
              animate="visible"
            >
              {/* Greeting */}
              <motion.p variants={itemVariants} className="hero-greeting">
                Hello, I am
              </motion.p>

              {/* Name */}
              <motion.h1 variants={itemVariants} className="hero-name">
                Riddhi <span>Patel</span>
              </motion.h1>

              {/* Title */}
              <motion.h2 variants={itemVariants} className="hero-title">
                Front-End Developer
              </motion.h2>

              {/* Description */}
              <motion.p variants={itemVariants} className="hero-description">
                I craft beautiful, responsive, and user-friendly web experiences. 
                Passionate about turning ideas into elegant digital solutions.
              </motion.p>

              {/* CTA Buttons */}
              <motion.div variants={itemVariants} className="hero-buttons">
                <Button 
                  className="btn-primary-custom"
                  onClick={scrollToContact}
                >
                  Get In Touch
                </Button>
                <Button 
                  className="btn-outline-custom"
                  onClick={scrollToProjects}
                >
                  View My Work
                </Button>
              </motion.div>
            </motion.div>
          </Col>
        </Row>

        {/* Scroll Indicator */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1.5, duration: 0.5 }}
          style={{
            position: 'absolute',
            bottom: '40px',
            left: '50%',
            transform: 'translateX(-50%)',
            cursor: 'pointer'
          }}
          onClick={() => document.getElementById('about').scrollIntoView({ behavior: 'smooth' })}
        >
          <motion.div
            animate={{ y: [0, 10, 0] }}
            transition={{ duration: 1.5, repeat: Infinity }}
          >
            <KeyboardArrowDownIcon sx={{ fontSize: 40, color: '#0f00ff' }} />
          </motion.div>
        </motion.div>
      </Container>
    </section>
  );
};

export default Hero;
